import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";
import microfrontendLayout from "./microfrontend-layout.html";




loadEventListeners();

const routes = constructRoutes(microfrontendLayout);
try {
  const applications = constructApplications({
    routes,
    loadApp({ name }) {
      return System.import(name);
    },
  });
  const layoutEngine = constructLayoutEngine({ routes, applications, active: true });

  applications.forEach(registerApplication);
  layoutEngine.activate();
} catch (error) {
  console.log(error)
}


start();

function loadEventListeners() {
  let modalidadeIdGeneral = 0;
  let permissions = null;
  let pendencies = null;

  window.addEventListener('setModalidadeIdSGRT', (event:any) => {    
    modalidadeIdGeneral = event.detail;
  });

  window.addEventListener('getSGRT', (event:any) => {
    if (event.detail === 'modalidadeId') {
      window.dispatchEvent(new CustomEvent('getSGRTModalidadeId', {detail: modalidadeIdGeneral}));
    }
  });

  // permissions

  window.addEventListener('savePermissions', (event:any) => {
   permissions = event.detail;
  });

  window.addEventListener('getPermissions', (event:any) => {
    window.dispatchEvent(new CustomEvent('setPermissons', {detail: permissions}));
  });

    // Pendencies

    window.addEventListener('savePendencies', (event:any) => {
      
      pendencies = event.detail;
     });
   
     window.addEventListener('getPendencies', (event:any) => {
      
       window.dispatchEvent(new CustomEvent('setPendencies', {detail: pendencies}));
     });
  
}

